/* eslint-disable max-lines */
import { lazyPreload } from 'helpers/lazyPreload'

export { AyahGender } from './SelectGender/v1/AyahGender/AyahGender'
export { AyahGenderFactory } from './SelectGender/v1/AyahGenderFactory'
export { AyahGenderV2 } from './SelectGender/v1/AyahGenderV2/AyahGenderV2'
export { SelectGenderAyah } from './SelectGender/v1/SelectGenderAyah'
export { SelectGenderV2 } from './SelectGender/v2/SelectGenderV2'
export { SelectGenderBlessV3 } from './SelectGender/v3/SelectGenderBlessV3'
export { SelectGenderKarma } from './SelectGender/v4/SelectGenderKarma'
export { SelectGenderParent } from './SelectGender/v5/SelectGenderParent'
export { SelectGenderArchetype } from './SelectGender/v6/SelectGenderArchetype'
export { SelectFamilySize } from './SelectFamilySize'
export { SelectFocusArea } from './SelectFocusArea'

export const Abilities = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.Abilities })),
)

export const AdditionalResources = lazyPreload(() =>
  import('./AdditionalResources').then((m) => ({
    default: m.AdditionalResources,
  })),
)

export const AdditionalResourcesAyah = lazyPreload(() =>
  import('./AdditionalResources').then((m) => ({
    default: m.AdditionalResourcesAyah,
  })),
)

export const AdditionalResourcesKarma = lazyPreload(() =>
  import('./AdditionalResources').then((m) => ({
    default: m.AdditionalResourcesKarma,
  })),
)

export const AdviceAyah = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.AdviceAyah })),
)

export const AffectedAria = lazyPreload(() =>
  import('./AffectedAria').then((m) => ({ default: m.AffectedAria })),
)

export const AgeFactory = lazyPreload(() =>
  import('./SelectAge').then((m) => ({ default: m.AgeFactory })),
)

export const AkhirahFeeling = lazyPreload(() =>
  import('./AkhirahFeeling').then((m) => ({ default: m.AkhirahFeeling })),
)

export const AnalyzingAnswers = lazyPreload(() =>
  import('./AnalyzingAnswers').then((m) => ({ default: m.AnalyzingAnswers })),
)

export const AnalyzingAnswersAyah = lazyPreload(() =>
  import('./AnalyzingAnswers').then((m) => ({
    default: m.AnalyzingAnswersAyah,
  })),
)

export const AnalyzingAnswersBlessV4 = lazyPreload(() =>
  import('./AnalyzingAnswers').then((m) => ({
    default: m.AnalyzingAnswersBlessV4,
  })),
)

export const AnalyzingAnswersKarma = lazyPreload(() =>
  import('./AnalyzingAnswers').then((m) => ({
    default: m.AnalyzingAnswersKarma,
  })),
)

export const AnalyzingAnswersV5 = lazyPreload(() =>
  import('./AnalyzingAnswers').then((m) => ({ default: m.AnalyzingAnswersV5 })),
)

export const Angry = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.Angry })),
)

export const AntistressMusic = lazyPreload(() =>
  import('./AntistressMusic').then((m) => ({ default: m.AntistressMusic })),
)

export const AriasToImprove = lazyPreload(() =>
  import('./AriasToImprove').then((m) => ({ default: m.AriasToImprove })),
)

export const AriasToImproveV2 = lazyPreload(() =>
  import('./AriasToImprove').then((m) => ({ default: m.AriasToImproveV2 })),
)

export const AriasToImproveV3 = lazyPreload(() =>
  import('./AriasToImprove').then((m) => ({ default: m.AriasToImproveV3 })),
)

export const AriasToImproveV4 = lazyPreload(() =>
  import('./AriasToImprove').then((m) => ({ default: m.AriasToImproveV4 })),
)

export const AriasToSupport = lazyPreload(() =>
  import('./AriasToSupport').then((m) => ({ default: m.AriasToSupport })),
)

export const AspectToImprove = lazyPreload(() =>
  import('./AspectToImprove').then((m) => ({ default: m.AspectToImprove })),
)

export const AttendCommunity = lazyPreload(() =>
  import('./AttendCommunity').then((m) => ({ default: m.AttendCommunity })),
)

export const AyahGoal = lazyPreload(() =>
  import('./AyahGoal').then((m) => ({ default: m.AyahGoal })),
)

export const BackgroundMusic = lazyPreload(() =>
  import('./BackgroundMusic').then((m) => ({ default: m.BackgroundMusic })),
)

export const BetterFinances = lazyPreload(() =>
  import('./BetterFinances').then((m) => ({ default: m.BetterFinances })),
)

export const BibleContent = lazyPreload(() =>
  import('./BibleContent').then((m) => ({ default: m.BibleContent })),
)

export const BibleContentV3 = lazyPreload(() =>
  import('./BibleContent').then((m) => ({ default: m.BibleContentV3 })),
)

export const BibleJourney = lazyPreload(() =>
  import('./BibleJourney').then((m) => ({ default: m.BibleJourney })),
)

export const BibleLessonsStyle = lazyPreload(() =>
  import('./BibleLessonsStyle').then((m) => ({ default: m.BibleLessonsStyle })),
)

export const BiblePurpose = lazyPreload(() =>
  import('./BiblePurpose').then((m) => ({ default: m.BiblePurpose })),
)

export const BibleVersion = lazyPreload(() =>
  import('./BibleVersion').then((m) => ({ default: m.BibleVersion })),
)

export const BiggestFinancialStruggle = lazyPreload(() =>
  import('./BiggestFinancialStruggle').then((m) => ({
    default: m.BiggestFinancialStruggle,
  })),
)

export const BoredomScrolling = lazyPreload(() =>
  import('./BoredomScrolling').then((m) => ({ default: m.BoredomScrolling })),
)

export const BuddhistPractice = lazyPreload(() =>
  import('./BuddhistPractice').then((m) => ({ default: m.BuddhistPractice })),
)

export const BudgetConfidence = lazyPreload(() =>
  import('./BudgetConfidence').then((m) => ({ default: m.BudgetConfidence })),
)

export const CalmDownAyah = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.CalmDownAyah })),
)

export const CareAyah = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.CareAyah })),
)

export const ChallengeAreasFactory = lazyPreload(() =>
  import('./ChallengeAreas').then((m) => ({
    default: m.ChallengeAreasFactory,
  })),
)

export const TransformChallengeAreas = lazyPreload(() =>
  import('./ChallengeAreas').then((m) => ({
    default: m.TransformChallengeAreas,
  })),
)

export const ChildhoodExperience = lazyPreload(() =>
  import('./ChildhoodExperience').then((m) => ({
    default: m.ChildhoodExperience,
  })),
)

export const CloseToGod = lazyPreload(() =>
  import('./CloseToGod').then((m) => ({ default: m.CloseToGod })),
)

export const CommitmentLevel = lazyPreload(() =>
  import('./CommitmentLevel').then((m) => ({ default: m.CommitmentLevel })),
)

export const ConcentrationImpact = lazyPreload(() =>
  import('./ConcentrationImpact').then((m) => ({
    default: m.ConcentrationImpact,
  })),
)

export const ConnectedToGod = lazyPreload(() =>
  import('./ConnectedToGod').then((m) => ({ default: m.ConnectedToGod })),
)

export const ConnectedToAllah = lazyPreload(() =>
  import('./ConnectedToAllah').then((m) => ({
    default: m.ConnectedToAllah,
  })),
)

export const ContentType = lazyPreload(() =>
  import('./ContentType').then((m) => ({ default: m.ContentType })),
)

export const ContentTypeV2 = lazyPreload(() =>
  import('./ContentTypeV2').then((m) => ({
    default: m.ContentTypeV2,
  })),
)

export const Criticize = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.Criticize })),
)

export const CurrentChallenges = lazyPreload(() =>
  import('./CurrentChallenges').then((m) => ({ default: m.CurrentChallenges })),
)

export const CurrentLifestyle = lazyPreload(() =>
  import('./CurrentLifestyle').then((m) => ({ default: m.CurrentLifestyle })),
)

export const DailyGoal = lazyPreload(() =>
  import('./DailyGoal').then((m) => ({ default: m.DailyGoal })),
)

export const DailyPractice = lazyPreload(() =>
  import('./DailyPractice').then((m) => ({ default: m.DailyPractice })),
)

export const DeepingFaith = lazyPreload(() =>
  import('./DeepingFaith').then((m) => ({ default: m.DeepingFaith })),
)

export const DescribeChallenge = lazyPreload(() =>
  import('./DescribeChallenge').then((m) => ({ default: m.DescribeChallenge })),
)

export const DiscoverAyah = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.DiscoverAyah })),
)

export const DistanceBetweenAllah = lazyPreload(() =>
  import('./DistanceBetweenAllah').then((m) => ({
    default: m.DistanceBetweenAllah,
  })),
)

export const DistanceBetweenYouAndGod = lazyPreload(() =>
  import('./DistanceBetweenYouAndGod').then((m) => ({
    default: m.DistanceBetweenYouAndGod,
  })),
)

export const DiveDeeper = lazyPreload(() =>
  import('./DiveDeeper').then((m) => ({ default: m.DiveDeeper })),
)

export const DopamineBalance = lazyPreload(() =>
  import('./DopamineBalance').then((m) => ({ default: m.DopamineBalance })),
)

export const DopamineDetox = lazyPreload(() =>
  import('./DopamineDetox').then((m) => ({ default: m.DopamineDetox })),
)

export const DopamineEffect = lazyPreload(() =>
  import('./DopamineEffect').then((m) => ({ default: m.DopamineEffect })),
)

export const EmotionsInFamily = lazyPreload(() =>
  import('./EmotionsInFamily').then((m) => ({ default: m.EmotionsInFamily })),
)

export const EnergyLevel = lazyPreload(() =>
  import('./EnergyLevel').then((m) => ({ default: m.EnergyLevel })),
)

export const EnergyLevelKarma = lazyPreload(() =>
  import('./EnergyLevel').then((m) => ({ default: m.EnergyLevelKarma })),
)

export const EnjoyListeningAyah = lazyPreload(() =>
  import('./EnjoyListeningDaily').then((m) => ({
    default: m.EnjoyListeningAyah,
  })),
)

export const EnjoyListeningDaily = lazyPreload(() =>
  import('./EnjoyListeningDaily').then((m) => ({
    default: m.EnjoyListeningDaily,
  })),
)

export const EnjoyListeningKarma = lazyPreload(() =>
  import('./EnjoyListeningDaily').then((m) => ({
    default: m.EnjoyListeningKarma,
  })),
)

export const EnjoyReadingAyah = lazyPreload(() =>
  import('./EnjoyReadingDaily').then((m) => ({ default: m.EnjoyReadingAyah })),
)

export const EnjoyReadingDaily = lazyPreload(() =>
  import('./EnjoyReadingDaily').then((m) => ({ default: m.EnjoyReadingDaily })),
)

export const Exercise = lazyPreload(() =>
  import('./Exercise').then((m) => ({ default: m.Exercise })),
)

export const ExplicitContent = lazyPreload(() =>
  import('./ExplicitContent').then((m) => ({ default: m.ExplicitContent })),
)

export const ExtraTools = lazyPreload(() =>
  import('./ExtraTools').then((m) => ({ default: m.ExtraTools })),
)

export const ExtraToolsV2 = lazyPreload(() =>
  import('./ExtraTools').then((m) => ({ default: m.ExtraToolsV2 })),
)

export const FaithDecisions = lazyPreload(() =>
  import('./FaithDecisions').then((m) => ({ default: m.FaithDecisions })),
)

export const FaithObstacleDetails = lazyPreload(() =>
  import('./FaithObstacleDetails').then((m) => ({
    default: m.FaithObstacleDetails,
  })),
)

export const FaithExample = lazyPreload(() =>
  import('./FaithExample').then((m) => ({ default: m.FaithExample })),
)

export const FaithRelationship = lazyPreload(() =>
  import('./FaithRelationship').then((m) => ({ default: m.FaithRelationship })),
)

export const FamiliarWithConcept = lazyPreload(() =>
  import('./FamiliarWithConcept').then((m) => ({
    default: m.FamiliarWithConcept,
  })),
)

export const FatihahMeaning = lazyPreload(() =>
  import('./FatihahMeaning').then((m) => ({ default: m.FatihahMeaning })),
)

export const FeelAfter = lazyPreload(() =>
  import('./FeelAfter').then((m) => ({ default: m.FeelAfter })),
)

export const FeelBetterAbout = lazyPreload(() =>
  import('./FeelBetterAbout').then((m) => ({ default: m.FeelBetterAbout })),
)

export const FeelExhausted = lazyPreload(() =>
  import('./FeelExhausted').then((m) => ({ default: m.FeelExhausted })),
)

export const FeelScripture = lazyPreload(() =>
  import('./FeelScripture').then((m) => ({ default: m.FeelScripture })),
)

export const FeelTired = lazyPreload(() =>
  import('./FeelTired').then((m) => ({ default: m.FeelTired })),
)

export const FeelingType = lazyPreload(() =>
  import('./FeelingType').then((m) => ({ default: m.FeelingType })),
)

export const FinanceStress = lazyPreload(() =>
  import('./FinanceStress').then((m) => ({ default: m.FinanceStress })),
)

export const FinancialMindset = lazyPreload(() =>
  import('./FinancialMindset').then((m) => ({ default: m.FinancialMindset })),
)

export const GrowPurpose = lazyPreload(() =>
  import('./GrowPurpose').then((m) => ({ default: m.GrowPurpose })),
)

export const GuidesToListen = lazyPreload(() =>
  import('./GuidesToListen').then((m) => ({ default: m.GuidesToListen })),
)

export const Guilty = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.Guilty })),
)

export const GuiltyTypeAyah = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.GuiltyTypeAyah })),
)

export const HabitTriggers = lazyPreload(() =>
  import('./HabitTriggers').then((m) => ({ default: m.HabitTriggers })),
)

export const HardToAchieve = lazyPreload(() =>
  import('./HardToAchieve').then((m) => ({ default: m.HardToAchieve })),
)

export const HelpFromAllah = lazyPreload(() =>
  import('./HelpFromAllah').then((m) => ({ default: m.HelpFromAllah })),
)

export const HeavyLife = lazyPreload(() =>
  import('./HeavyLife').then((m) => ({ default: m.HeavyLife })),
)

export const Hello = lazyPreload(() =>
  import('./Hello').then((m) => ({ default: m.Hello })),
)

export const IdealPlace = lazyPreload(() =>
  import('./IdealPlace').then((m) => ({ default: m.IdealPlace })),
)

export const ImanExample = lazyPreload(() =>
  import('./ImanExample').then((m) => ({ default: m.ImanExample })),
)

export const IncomeStability = lazyPreload(() =>
  import('./IncomeStability').then((m) => ({ default: m.IncomeStability })),
)

export const InspirationAyah = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.InspirationAyah })),
)

export const InspiredScripture = lazyPreload(() =>
  import('./InspiredScripture').then((m) => ({ default: m.InspiredScripture })),
)

export const InstinctAyah = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.InstinctAyah })),
)

export const IssueDuration = lazyPreload(() =>
  import('./IssueDuration').then((m) => ({ default: m.IssueDuration })),
)

export const IssueDurationV2 = lazyPreload(() =>
  import('./IssueDuration').then((m) => ({ default: m.IssueDurationV2 })),
)

export const KarmaContent = lazyPreload(() =>
  import('./KarmaContent').then((m) => ({ default: m.KarmaContent })),
)

export const KarmaGoal = lazyPreload(() =>
  import('./KarmaGoal').then((m) => ({ default: m.KarmaGoal })),
)

export const KnownIngredients = lazyPreload(() =>
  import('./KnownIngredients').then((m) => ({ default: m.KnownIngredients })),
)

export const LastTimeFocused = lazyPreload(() =>
  import('./LastTimeFocused').then((m) => ({ default: m.LastTimeFocused })),
)

export const LearningStyle = lazyPreload(() =>
  import('./LearningStyle').then((m) => ({ default: m.LearningStyle })),
)

export const LessonLength = lazyPreload(() =>
  import('./LessonLength').then((m) => ({ default: m.LessonLength })),
)

export const LifeImpact = lazyPreload(() =>
  import('./LifeImpact').then((m) => ({ default: m.LifeImpact })),
)

export const LifeVision = lazyPreload(() =>
  import('./LifeVision').then((m) => ({ default: m.LifeVision })),
)

export const LifeWithoutAddiction = lazyPreload(() =>
  import('./LifeWithoutAddiction').then((m) => ({
    default: m.LifeWithoutAddiction,
  })),
)

export const LostInterest = lazyPreload(() =>
  import('./LostInterest').then((m) => ({ default: m.LostInterest })),
)

export const MainFinancialGoal = lazyPreload(() =>
  import('./MainFinancialGoal').then((m) => ({ default: m.MainFinancialGoal })),
)

export const MakeYouFeel = lazyPreload(() =>
  import('./MakeYouFeel').then((m) => ({ default: m.MakeYouFeel })),
)

export const MattersMost = lazyPreload(() =>
  import('./MattersMost').then((m) => ({ default: m.MattersMost })),
)

export const MeaningfulStudy = lazyPreload(() =>
  import('./MeaningfulStudy').then((m) => ({ default: m.MeaningfulStudy })),
)

export const MindAyah = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.MindAyah })),
)

export const MoneyInLife = lazyPreload(() =>
  import('./MoneyInLife').then((m) => ({ default: m.MoneyInLife })),
)

export const MoneyVision = lazyPreload(() =>
  import('./MoneyVision').then((m) => ({ default: m.MoneyVision })),
)

export const MonthAheadGoal = lazyPreload(() =>
  import('./MonthAheadGoal').then((m) => ({ default: m.MonthAheadGoal })),
)

export const MoreToLearn = lazyPreload(() =>
  import('./MoreToLearn').then((m) => ({ default: m.MoreToLearn })),
)

export const MostInspired = lazyPreload(() =>
  import('./MostInspired').then((m) => ({ default: m.MostInspired })),
)

export const MostInspiredAyah = lazyPreload(() =>
  import('./MostInspired').then((m) => ({ default: m.MostInspiredAyah })),
)

export const MostInspiredKarma = lazyPreload(() =>
  import('./MostInspired').then((m) => ({ default: m.MostInspiredKarma })),
)

export const MotivationLevel = lazyPreload(() =>
  import('./MotivationLevel').then((m) => ({ default: m.MotivationLevel })),
)

export const MotivationLevelV2 = lazyPreload(() =>
  import('./MotivationLevel').then((m) => ({ default: m.MotivationLevelV2 })),
)

export const MultiAyahGoal = lazyPreload(() =>
  import('./AyahGoal').then((m) => ({ default: m.MultiAyahGoal })),
)

export const MultiChallengeAreas = lazyPreload(() =>
  import('./ChallengeAreas').then((m) => ({ default: m.MultiChallengeAreas })),
)

export const MuslimBackground = lazyPreload(() =>
  import('./MuslimBackground').then((m) => ({ default: m.MuslimBackground })),
)

export const NarratorVoice = lazyPreload(() =>
  import('./NarratorVoice').then((m) => ({ default: m.NarratorVoice })),
)

export const NegativeEffect = lazyPreload(() =>
  import('./NegativeEffect').then((m) => ({ default: m.NegativeEffect })),
)

export const NegativeSituations = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({
    default: m.NegativeSituations,
  })),
)

export const NewChallengeAyah = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({
    default: m.NewChallengeAyah,
  })),
)

export const NewThings = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.NewThings })),
)

export const ObstaclesToStudy = lazyPreload(() =>
  import('./ObstaclesToStudy').then((m) => ({ default: m.ObstaclesToStudy })),
)

export const OnlineDaily = lazyPreload(() =>
  import('./OnlineDaily').then((m) => ({ default: m.OnlineDaily })),
)

export const OtherOpinion = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.OtherOpinion })),
)

export const Outcome = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.Outcome })),
)

export const OverallState = lazyPreload(() =>
  import('./OverallState').then((m) => ({ default: m.OverallState })),
)

export const Overwhelmed = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.Overwhelmed })),
)

export const ChildQuranRoutine = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({
    default: m.ChildQuranRoutine,
  })),
)

export const HardFaithQuestions = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({
    default: m.HardFaithQuestions,
  })),
)

export const ParentWorriesSingle = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({
    default: m.ParentWorriesSingle,
  })),
)

export const ChildDisobeys = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.ChildDisobeys })),
)

export const LosingTemper = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({
    default: m.LosingTemper,
  })),
)

export const ScreensInterrupt = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({
    default: m.ScreensInterrupt,
  })),
)

export const RaisedAsChild = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.RaisedAsChild })),
)

export const UpbringingToAvoid = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({
    default: m.UpbringingToAvoid,
  })),
)

export const IdentityPride = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.IdentityPride })),
)

export const HighestHope = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.HighestHope })),
)

export const StartWith = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.StartWith })),
)

export const StudyQuranBest = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.StudyQuranBest })),
)

export const ChildWorldView = lazyPreload(() =>
  import('./ChildWorldView').then((m) => ({ default: m.ChildWorldView })),
)

export const ScreenStruggle = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.ScreenStruggle })),
)

export const ParentFears = lazyPreload(() =>
  import('./ParentFears').then((m) => ({ default: m.ParentFears })),
)

export const ChildTantrums = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.ChildTantrums })),
)

export const ReactionGuilt = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.ReactionGuilt })),
)

export const AfterOverreacting = lazyPreload(() =>
  import('./AfterOverreacting').then((m) => ({ default: m.AfterOverreacting })),
)

export const FamilyBondGoal = lazyPreload(() =>
  import('./FamilyBondGoal').then((m) => ({ default: m.FamilyBondGoal })),
)

export const QuranTimeFit = lazyPreload(() =>
  import('./QuranTimeFit').then((m) => ({ default: m.QuranTimeFit })),
)

export const ChildDuas = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.ChildDuas })),
)

export const BedtimeSunnah = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.BedtimeSunnah })),
)

export const SelectGenderList = lazyPreload(() =>
  import('./SelectGender').then((m) => ({ default: m.SelectGenderList })),
)

export const ParentingLoad = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.ParentingLoad })),
)

export const FeelingLately = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.FeelingLately })),
)

export const ParentingOverwhelm = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({
    default: m.ParentingOverwhelm,
  })),
)

export const SabrChallenge = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.SabrChallenge })),
)

export const ChildCloseness = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.ChildCloseness })),
)

export const DisobeyReaction = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.DisobeyReaction })),
)

export const TemperAftermath = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.TemperAftermath })),
)

export const HearOwnParents = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.HearOwnParents })),
)

export const PushToPractice = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.PushToPractice })),
)

export const AllahInTenseMoments = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({
    default: m.AllahInTenseMoments,
  })),
)

export const ChildFaithWorries = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({
    default: m.ChildFaithWorries,
  })),
)

export const AllahConnection = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.AllahConnection })),
)

export const DuaUnderStress = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.DuaUnderStress })),
)

export const DesiredReaction = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.DesiredReaction })),
)

export const ChildrenCount = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.ChildrenCount })),
)

export const QuranAtHome = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.QuranAtHome })),
)

export const ChildrenAge = lazyPreload(() =>
  import('./ChildrenAge').then((m) => ({ default: m.ChildrenAge })),
)

export const FamilyShapeV2 = lazyPreload(() =>
  import('./FamilyShape').then((m) => ({ default: m.FamilyShapeV2 })),
)

export const PartsToExplore = lazyPreload(() =>
  import('./PartsToExplore').then((m) => ({ default: m.PartsToExplore })),
)

export const PersonalNeed = lazyPreload(() =>
  import('./PersonalNeed').then((m) => ({ default: m.PersonalNeed })),
)

export const PlanPreparationAyah = lazyPreload(() =>
  import('./PlanPreparation').then((m) => ({ default: m.PlanPreparationAyah })),
)

export const PlanPreparationKarma = lazyPreload(() =>
  import('./PlanPreparation').then((m) => ({
    default: m.PlanPreparationKarma,
  })),
)

export const PlanToUse = lazyPreload(() =>
  import('./PlanToUse').then((m) => ({ default: m.PlanToUse })),
)

export const PornToCope = lazyPreload(() =>
  import('./PornToCope').then((m) => ({ default: m.PornToCope })),
)

export const PositiveHabits = lazyPreload(() =>
  import('./PositiveHabits').then((m) => ({ default: m.PositiveHabits })),
)

export const PotentialBlock = lazyPreload(() =>
  import('./PotentialBlock').then((m) => ({ default: m.PotentialBlock })),
)

export const PracticeSpiritual = lazyPreload(() =>
  import('./PracticeSpiritual').then((m) => ({ default: m.PracticeSpiritual })),
)

export const PrayerLife = lazyPreload(() =>
  import('./PrayerLife').then((m) => ({ default: m.PrayerLife })),
)

export const PrayerType = lazyPreload(() =>
  import('./PrayerType').then((m) => ({ default: m.PrayerType })),
)

export const PresentStruggles = lazyPreload(() =>
  import('./PresentStruggles').then((m) => ({ default: m.PresentStruggles })),
)

export const PromicesAyah = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.PromicesAyah })),
)

export const PsalmsUnderstanding = lazyPreload(() =>
  import('./PsalmsUnderstanding').then((m) => ({
    default: m.PsalmsUnderstanding,
  })),
)

export const QuitGoal = lazyPreload(() =>
  import('./QuitGoal').then((m) => ({ default: m.QuitGoal })),
)

export const QuoteAyah = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.QuoteAyah })),
)

export const QuranContent = lazyPreload(() =>
  import('./QuranContent').then((m) => ({ default: m.QuranContent })),
)

export const QuranContentV2 = lazyPreload(() =>
  import('./QuranContent').then((m) => ({ default: m.QuranContentV2 })),
)

export const QuranGoal = lazyPreload(() =>
  import('./QuranGoal').then((m) => ({ default: m.QuranGoal })),
)

export const QuranLessons = lazyPreload(() =>
  import('./QuranLessons').then((m) => ({ default: m.QuranLessons })),
)

export const QuranStudyTime = lazyPreload(() =>
  import('./QuranStudyTime').then((m) => ({ default: m.QuranStudyTime })),
)

export const QuranDiscussion = lazyPreload(() =>
  import('./QuranDiscussion').then((m) => ({ default: m.QuranDiscussion })),
)

export const ReadListenQuran = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.ReadListenQuran })),
)

export const ReadOrListen = lazyPreload(() =>
  import('./ReadOrListen').then((m) => ({ default: m.ReadOrListen })),
)

export const ReadingPlaceAyah = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({
    default: m.ReadingPlaceAyah,
  })),
)

export const ReadyToBegin = lazyPreload(() =>
  import('./ReadyToRenewal').then((m) => ({ default: m.ReadyToBegin })),
)

export const ReadyToGrowCloser = lazyPreload(() =>
  import('./ReadyToGrowCloser').then((m) => ({
    default: m.ReadyToGrowCloser,
  })),
)

export const ReadyToRenewal = lazyPreload(() =>
  import('./ReadyToRenewal').then((m) => ({ default: m.ReadyToRenewal })),
)

export const ReasonFeelingWorse = lazyPreload(() =>
  import('./ReasonFeelingWorse').then((m) => ({
    default: m.ReasonFeelingWorse,
  })),
)

export const ReferredBy = lazyPreload(() =>
  import('./ReferredBy').then((m) => ({ default: m.ReferredBy })),
)

export const ReflectionResult = lazyPreload(() =>
  import('./ReflectionResult').then((m) => ({ default: m.ReflectionResult })),
)

export const RelationshipGoingOn = lazyPreload(() =>
  import('./RelationshipGoingOn').then((m) => ({
    default: m.RelationshipGoingOn,
  })),
)

export const RelationshipStatus = lazyPreload(() =>
  import('./RelationshipStatus').then((m) => ({
    default: m.RelationshipStatus,
  })),
)

export const RelationshipWithCaregiver = lazyPreload(() =>
  import('./RelationshipWithCaregiver').then((m) => ({
    default: m.RelationshipWithCaregiver,
  })),
)

export const RelationshipWithGod = lazyPreload(() =>
  import('./RelationshipWithGod').then((m) => ({
    default: m.RelationshipWithGod,
  })),
)

export const Rest = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.Rest })),
)

export const SalahLife = lazyPreload(() =>
  import('./SalahLife').then((m) => ({ default: m.SalahLife })),
)

export const SalahMeaning = lazyPreload(() =>
  import('./SalahMeaning').then((m) => ({ default: m.SalahMeaning })),
)

export const SelectAgeV2 = lazyPreload(() =>
  import('./SelectAge').then((m) => ({ default: m.SelectAgeV2 })),
)

export const SelectAgeV3 = lazyPreload(() =>
  import('./SelectAge').then((m) => ({ default: m.SelectAgeV3 })),
)

export const SelectAgeV4 = lazyPreload(() =>
  import('./SelectAge').then((m) => ({ default: m.SelectAgeV4 })),
)

export const SinglePresentStruggles = lazyPreload(() =>
  import('./PresentStruggles').then((m) => ({
    default: m.SinglePresentStruggles,
  })),
)

export const SleepIssues = lazyPreload(() =>
  import('./SleepIssues').then((m) => ({ default: m.SleepIssues })),
)

export const SpeakArabic = lazyPreload(() =>
  import('./SpeakArabic').then((m) => ({ default: m.SpeakArabic })),
)

export const SpiritualActivities = lazyPreload(() =>
  import('./SpiritualActivities').then((m) => ({
    default: m.SpiritualActivities,
  })),
)

export const StayFocused = lazyPreload(() =>
  import('./StayFocused').then((m) => ({ default: m.StayFocused })),
)

export const StayMotivated = lazyPreload(() =>
  import('./StayMotivated').then((m) => ({ default: m.StayMotivated })),
)

export const StayOnTrack = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.StayOnTrack })),
)

export const StoryAyah = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.StoryAyah })),
)

export const StressCosts = lazyPreload(() =>
  import('./StressCosts').then((m) => ({ default: m.StressCosts })),
)

export const StressLevel = lazyPreload(() =>
  import('./StressLevel').then((m) => ({ default: m.StressLevel })),
)

export const StressTriggers = lazyPreload(() =>
  import('./StressTriggers').then((m) => ({ default: m.StressTriggers })),
)

export const StructuredRoutine = lazyPreload(() =>
  import('./StructuredRoutine').then((m) => ({ default: m.StructuredRoutine })),
)

export const StruggleFinances = lazyPreload(() =>
  import('./StruggleFinances').then((m) => ({ default: m.StruggleFinances })),
)

export const StruggleWithInsomnia = lazyPreload(() =>
  import('./StruggleWithInsomnia').then((m) => ({
    default: m.StruggleWithInsomnia,
  })),
)

export const StudyBuddhism = lazyPreload(() =>
  import('./StudyBuddhism').then((m) => ({ default: m.StudyBuddhism })),
)

export const StudyQuran = lazyPreload(() =>
  import('./StudyQuran').then((m) => ({ default: m.StudyQuran })),
)

export const StudyTheBible = lazyPreload(() =>
  import('./StudyTheBible').then((m) => ({ default: m.StudyTheBible })),
)

export const SurahUnderstanding = lazyPreload(() =>
  import('./SurahUnderstanding').then((m) => ({
    default: m.SurahUnderstanding,
  })),
)

export const TestAlcohol = lazyPreload(() =>
  import('./KnowledgeTests').then((m) => ({ default: m.TestAlcohol })),
)

export const TestCoffee = lazyPreload(() =>
  import('./KnowledgeTests').then((m) => ({ default: m.TestCoffee })),
)

export const TestTattoo = lazyPreload(() =>
  import('./KnowledgeTests').then((m) => ({ default: m.TestTattoo })),
)

export const TimeToStudyBible = lazyPreload(() =>
  import('./TimeToStudyBible').then((m) => ({ default: m.TimeToStudyBible })),
)

export const TrackYourProgress = lazyPreload(() =>
  import('./TrackYourProgress').then((m) => ({ default: m.TrackYourProgress })),
)

export const TranslationQuran = lazyPreload(() =>
  import('./TranslationQuran').then((m) => ({ default: m.TranslationQuran })),
)

export const TriedToStop = lazyPreload(() =>
  import('./TriedToStop').then((m) => ({ default: m.TriedToStop })),
)

export const TurnOnReminders = lazyPreload(() =>
  import('./TurnOnReminders').then((m) => ({ default: m.TurnOnReminders })),
)

export const TurnOnRemindersAyah = lazyPreload(() =>
  import('./TurnOnReminders').then((m) => ({ default: m.TurnOnRemindersAyah })),
)

export const TurnToAllah = lazyPreload(() =>
  import('./TurnToAllah').then((m) => ({ default: m.TurnToAllah })),
)

export const TurnToGod = lazyPreload(() =>
  import('./TurnToGod').then((m) => ({ default: m.TurnToGod })),
)

export const TypicalDay = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.TypicalDay })),
)

export const Uncomfortable = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.Uncomfortable })),
)

export const EnergyLately = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.EnergyLately })),
)

export const SleepQuality = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.SleepQuality })),
)

export const FeelStressed = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.FeelStressed })),
)

export const DigestionQuality = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({
    default: m.DigestionQuality,
  })),
)

export const FaithInWellness = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.FaithInWellness })),
)

export const NaturalRemedies = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.NaturalRemedies })),
)

export const TriedSunnahRemedies = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({
    default: m.TriedSunnahRemedies,
  })),
)

export const WellnessSupportTime = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({
    default: m.WellnessSupportTime,
  })),
)

export const GuideFrequency = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.GuideFrequency })),
)

export const PeopleLove = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.PeopleLove })),
)

export const RechargeWay = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.RechargeWay })),
)

export const ShowLove = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.ShowLove })),
)

export const PlansFallApart = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.PlansFallApart })),
)

export const AlwaysBusy = lazyPreload(() =>
  import('./AgreeScaleOptions').then((m) => ({ default: m.AlwaysBusy })),
)

export const StartMore = lazyPreload(() =>
  import('./AgreeScaleOptions').then((m) => ({ default: m.StartMore })),
)

export const HomeTriggers = lazyPreload(() =>
  import('./AgreeScaleOptions').then((m) => ({ default: m.HomeTriggers })),
)

export const OthersFirst = lazyPreload(() =>
  import('./AgreeScaleOptions').then((m) => ({ default: m.OthersFirst })),
)

export const PrayersSlip = lazyPreload(() =>
  import('./AgreeScaleOptions').then((m) => ({ default: m.PrayersSlip })),
)

export const FamilyReaction = lazyPreload(() =>
  import('./AgreeScaleOptions').then((m) => ({ default: m.FamilyReaction })),
)

export const KnockTimes = lazyPreload(() =>
  import('./QuizTilesOptions').then((m) => ({ default: m.KnockTimes })),
)

export const QuranWoman = lazyPreload(() =>
  import('./QuizTilesOptions').then((m) => ({ default: m.QuranWoman })),
)

export const BismillahSurah = lazyPreload(() =>
  import('./QuizTilesOptions').then((m) => ({
    default: m.BismillahSurah,
  })),
)

export const LostMoney = lazyPreload(() =>
  import('./QuizTilesOptions').then((m) => ({ default: m.LostMoney })),
)

export const WipesSins = lazyPreload(() =>
  import('./QuizTilesOptions').then((m) => ({ default: m.WipesSins })),
)

export const HonestQuestion = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.HonestQuestion })),
)

export const QuranStage = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.QuranStage })),
)

export const LearningReason = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.LearningReason })),
)

export const LearnFirst = lazyPreload(() =>
  import('./LearnFirst').then((m) => ({ default: m.LearnFirst })),
)

export const MuslimGoal = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.MuslimGoal })),
)

export const HalalHaramCards = lazyPreload(() =>
  import('./HalalHaramCards').then((m) => ({ default: m.HalalHaramCards })),
)

export const MovingStory = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.MovingStory })),
)

export const SupportGoals = lazyPreload(() =>
  import('./SupportGoals').then((m) => ({ default: m.SupportGoals })),
)

export const QuranLevel = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.QuranLevel })),
)

export const BestTime = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.BestTime })),
)

export const DailyMinutes = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.DailyMinutes })),
)

export const StableQuestion = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.StableQuestion })),
)

export const StableContinue = lazyPreload(() =>
  import('./SingleSelectOptions').then((m) => ({ default: m.StableContinue })),
)

export const WealthPrinciples = lazyPreload(() =>
  import('./WealthPrinciples').then((m) => ({ default: m.WealthPrinciples })),
)

export const WhatBroughtYou = lazyPreload(() =>
  import('./WhatBroughtYou').then((m) => ({ default: m.WhatBroughtYou })),
)

export const WhenToStudy = lazyPreload(() =>
  import('./WhenToStudy').then((m) => ({ default: m.WhenToStudy })),
)

export const WisdomOfProverbs = lazyPreload(() =>
  import('./WisdomOfProverbs').then((m) => ({ default: m.WisdomOfProverbs })),
)

export const ChallengeAreas = lazyPreload(() =>
  import('./ChallengeAreas').then((m) => ({ default: m.ChallengeAreas })),
)
